import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import FlagIcon from "assets/img/icons/flag.png";
import CommentForm from "./comp/CommentForm";
import ReplyForm from "./comp/ReplyForm";
import ReplyComponenet from "./comp/ReplyComponenet";
import { useAuth } from "provider/AuthContext";
import DummyUser from "assets/img/dpmain.png";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { obfuscateSensitiveNumbers } from "Data/regx";

const UserComments = () => {
  const {  packSlug } = useParams();
  const { isLoggedIn, userProfile, logout } = useAuth();
  const { packageViewData, userComments, packageViewLoading, safariPackagesDispatch } = useSafariPackagesContext();
  const { sharedSafariDispatch } = useSharedSafariContext();
  const containerRef = useRef(null);
  const repliesRefs = useRef({});
  const replyFormRefs = useRef({});
  const [replyFormVisibleFor, setReplyFormVisibleFor] = useState(null);
  const [visibleReplies, setVisibleReplies] = useState({});
  const [loading, setLoading] = useState();

  const toggleReplies = (commentId) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };
  const toggleReplyForm = (commentId) => {
    setReplyFormVisibleFor((prev) => (prev === commentId ? null : commentId));
  };

  useLayoutEffect(() => {
    Object.entries(visibleReplies).forEach(([commentId, isVisible]) => {
      if (isVisible && repliesRefs.current[commentId]) {
        const el = repliesRefs.current[commentId].current;
        if (el) el.style.maxHeight = `${el.scrollHeight}px`;
      }
    });
  }, [visibleReplies, userComments]);

  useEffect(() => {
    if (replyFormVisibleFor != null && containerRef.current) {
      const containerEl = containerRef.current;

      containerEl.scrollBy({
        top: 180, // scroll down 180px
        behavior: "smooth",
      });
    }
  }, [replyFormVisibleFor]);

  return (
    <>
      <div
        className="commentsOther comment_hightfixed position-relative border-bottom-0"
        ref={containerRef}
      >
        {/* Comment 1 */}
        {Array.isArray(userComments) && userComments?.length > 0 ? (
          (userComments || []).map((comment) => {
            if (!repliesRefs.current[comment.id]) {
              repliesRefs.current[comment.id] = React.createRef();
            }

            if (!replyFormRefs.current[comment.id]) {
              replyFormRefs.current[comment.id] = React.createRef();
            }

            return (
              <div className="one_box position-relative" key={comment.id}>
                {isLoggedIn && (
                  <div
                    className="objec-flgs"
                    onClick={() => {
                      sharedSafariDispatch({
                        type: "SET_SHARED_COMMENT_FOR_FLAG",
                        payload: null,
                      });
                      sharedSafariDispatch({
                        type: "SET_SHARED_COMMENT_FOR_FLAG",
                        payload: comment,
                      });
                      sharedSafariDispatch({
                        type: "SET_SHARED_SAFARI_REPORT_CONTENT_TOGGLE",
                        payload: true,
                      });
                    }}
                  >
                    <img src={FlagIcon} alt="Flag" className="flagBtn" />
                  </div>
                )}
                <div className="postcomment d-flex gap-2 pt-3 w-100">
                  <div className="avatar">
                    <Link to={`/profile/user/${comment?.user?.user_handle}`}>
                      <img
                        src={comment?.user?.profile_display_image || DummyUser}
                        alt="Profile"
                        className="rounded-circle"
                        title={comment?.user?.display_name || "User"}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = DummyUser;
                        }}
                      />
                    </Link>
                  </div>
                  <div className="text_com">
                    <div className="requestContact d-flex gap-2 align-items-center font-color">
                      <Link to={`/profile/user/${comment?.user?.user_handle}`}>
                        <span className="comment-author">
                          {comment?.user?.display_name}
                        </span>
                      </Link>
                      <span className="comment-date">{comment?.date_time}</span>
                    </div>
                    <p>{obfuscateSensitiveNumbers(comment?.comment)}</p>
                    {packageViewData?.can_reply && (
                      <button
                        className="reply_btn"
                        onClick={() => toggleReplyForm(comment.id)}
                      >
                        <i className="fa-solid fa-reply me-1"></i>Reply
                      </button>
                    )}
                  </div>
                </div>

                {/* Replies */}
                {comment?.replies?.length > 0 && (
                  <div className="comment-reply-wrapper px-4">
                    <h6
                      className="card-brown-heading pb-2 ms-lg-4 ms-2 pt-2 toggle-replies"
                      onClick={() => toggleReplies(comment.id)}
                      style={{ cursor: "pointer" }}
                    >
                      {visibleReplies[comment.id]
                        ? "Hide replies"
                        : "View replies"}
                    </h6>

                    <div
                      className="replies-container"
                      ref={repliesRefs.current[comment.id]}
                      style={{
                        maxHeight: visibleReplies[comment.id]
                          ? `${
                              repliesRefs?.current[comment.id]?.current
                                ?.scrollHeight
                            }px`
                          : "0px",
                        opacity: visibleReplies[comment.id] ? 1 : 0,
                        overflow: "hidden",
                        transition: "max-height 0.7s ease, opacity 0.7s ease",
                      }}
                    >
                      {comment?.replies?.map((replie, idx) => (
                        <ReplyComponenet replie={replie} key={replie?.id} />
                      ))}
                    </div>
                  </div>
                )}
                {/* Conditional Reply Form */}
                {packageViewData?.can_reply && (
                  <div
                    className="reply-form ms-lg-4 ms-2"
                    id={`reply-form-${comment.id}`}
                    ref={replyFormRefs.current[comment.id]}
                    style={{
                      maxHeight:
                        replyFormVisibleFor === comment.id ? "500px" : "0px",
                      opacity: replyFormVisibleFor === comment.id ? 1 : 0,
                      overflow: "hidden",
                      transition: "max-height 0.7s ease, opacity 0.7s ease",
                    }}
                  >
                    <ReplyForm
                      parentId={comment.id}
                      setReplyFormVisibleFor={setReplyFormVisibleFor}
                    />
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>

      {/* Comment Form */}
      {packageViewData?.can_comment ? (
        <CommentForm setLoading={setLoading} />
      ) : (
        <p class="text-center">
          Please 
          <Link 
          to={`/log-in?authclient=google&referrer=${encodeURIComponent(`/package/${packSlug}`)}`}
          class="sign_intext parkrevieBtn">Sign in</Link> 
          to Comment</p>
      )}
    </>
  );
};

export default UserComments;
